export const checkIfStringContainsProtocol = (url: string) => {
  const regex = new RegExp('^(?:[a-z]+:)?//', 'i');
  return regex.test(url);
}
